import { EntityDocfileImple } from "../entity/EntityDocfileImple";
import { EntityHistoryImple } from "../entity/EntityHistoryImple";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoDocsGetRes } from "./abst/DtoDocsGetRes";
import { EntityProject } from "../entity/EntityProject";
import { EntityPro2doc } from "../entity/EntityPro2doc";

export class DtoDocsGetResImple extends DtoDocsGetRes {
  public pager = new DtoApiPager();
  public items4docFile: EntityDocfileImple[] = [];
  public items4History: EntityHistoryImple[] = [];

  //関連案件
  //-------
  /**
   * 紐付いている案件
   */
  public projects: EntityProject[] = [];
  public pro2Doc: EntityPro2doc[] = [];

  //連携ページへのリンク
  //-------
  /**
   * 請求書
   */
  public link4Claim: string | null = null;
  /**
   * 経費精算書
   */
  public link4Expensess: string | null = null;
}
